
import Loadable from 'react-loadable';
import Spinner from '../../components/spinner';


export default Loadable({
  loader: () => import(/* webpackChunkName: "TripCreate"*/'./trip-create'),
  loading: Spinner
});
